import { useContext, useEffect, useState } from "react";
import { CurrentUserContext } from "../../context/CurrentUserContext";
import './Profile.css'

export function UserProfile() {
  const { currentUser } = useContext(CurrentUserContext);
  console.log(currentUser);
  
  const [user, setUser] = useState<ProfileProps | any>({
    email: "",
    password: "",
    name: "",
    picture: "",
  role: "",
  });
  
  useEffect(() => {
    if (currentUser) {
      setUser(currentUser)
    }
    
    
  }, [currentUser, user])
  
  
  
  type ProfileProps = () => {
    email: string,
    name: string,
    picture: string,
    role: string
  }
  
  return (
    <div>
      <h1>Profile Page</h1>
      <img src={user?.picture} alt={`${user.name} pic`} className="ProfileImage"/>
      <h2 className="ProfileName">{user.name}</h2>
      <p>{user.email}</p>
      <p>{user._id}</p>
    </div>
  )
}